import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { StaffCard } from 'features/staff-and-rooms';
import MaterialIcon from 'material-icons-react';

const defaultList = [];

const StaffList = (props) => {
  const { t } = useTranslation();
  const [list, setList] = useState(
    props.list.length ? props.list : props.showDelete ? defaultList : []
  );

  useEffect(() => {
    setList(props.list.length ? props.list : defaultList);
  }, [props.list]);

  const renderList = (index) => (
    <StaffCard
      staff={props.list[index]}
      title={`${props.roleTitle} #${index + 1}`}
      roleId={props.roleId}
      room={props.room}
      onOpenModal={props.onOpenModal}
      onRemoveStaffRole={onRemoveStaffRole}
      showDelete={props.showDelete}
      key={`proctor-${index}`}
    />
  );

  const onAddNewStaff = () => {
    setList([...list, {}]);
  };

  const onRemoveStaffRole = (staff) => {
    if (isEmpty(staff)) {
      const idx = list.findIndex((el) => isEmpty(el));
      const newList = [...list];
      newList.splice(idx, 1);
      setList(newList);
    } else {
      props.onRemoveStaffRole(staff, true);
    }
  };

  return (
    <div>
      {list.map((proctor, i) => renderList(i))}
      {props.showDelete && (
        <button
          className="pl-0 btn-link text-pacific-blue text-strong add-button"
          disabled={!isEmpty(list) && isEmpty(list.slice(-1)[0])}
          onClick={onAddNewStaff}>
          <span className="fw-bold">
            <MaterialIcon icon="control_point" size="tiny" /> {t(props.addLabel)}
          </span>
        </button>
      )}
    </div>
  );
};

export default StaffList;

StaffList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({})),
  roleTitle: PropTypes.string.isRequired,
  roleId: PropTypes.string.isRequired,
  room: PropTypes.shape({}).isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onRemoveStaffRole: PropTypes.func.isRequired,
  showDelete: PropTypes.bool,
  addLabel: PropTypes.string.isRequired,
};
